import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import Layout from "./components/Layout";
import LoginPage from "./pages/LoginPage";
import SignupPage from "./pages/SignupPage";
import DashboardPage from "./pages/DashboardPage";
import VendorsPage from "./pages/VendorsPage";
import RateCalculatorPage from "./pages/RateCalculatorPage";
import QuotationsPage from "./pages/QuotationsPage";
import CreateQuotationPage from "./pages/CreateQuotationPage";
import QuotationDetailPage from "./pages/QuotationDetailPage";
import CustomersPage from "./pages/CustomersPage";
import DesignCatalogPage from "./pages/DesignCatalogPage";
import { Toaster } from "sonner";

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="text-center">
          <div className="w-10 h-10 rounded-lg bg-[#ed8936] flex items-center justify-center font-bold text-white font-['Outfit'] text-lg mx-auto mb-3 animate-pulse">LS</div>
          <p className="text-slate-400 text-sm">Loading...</p>
        </div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function PublicRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (user) return <Navigate to="/dashboard" replace />;
  return children;
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<PublicRoute><LoginPage /></PublicRoute>} />
          <Route path="/signup" element={<PublicRoute><SignupPage /></PublicRoute>} />
          <Route path="/" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
            <Route index element={<Navigate to="/dashboard" replace />} />
            <Route path="dashboard" element={<DashboardPage />} />
            <Route path="vendors" element={<VendorsPage />} />
            <Route path="calculator" element={<RateCalculatorPage />} />
            <Route path="quotations" element={<QuotationsPage />} />
            <Route path="quotations/new" element={<CreateQuotationPage />} />
            <Route path="quotations/:id/edit" element={<CreateQuotationPage />} />
            <Route path="quotations/:id" element={<QuotationDetailPage />} />
            <Route path="customers" element={<CustomersPage />} />
            <Route path="catalog" element={<DesignCatalogPage />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
